<form
  [formGroup]="formData"
  novalidate
  (ngSubmit)="save()"
  [ngClass]="{ submitted: submitted }"
>
  <div class="modal-header">
    <h4 class="modal-title">Conversion Rule</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Unit Class</label>
          <input
            type="text"
            disabled
            class="form-control"
            [value]="rfq?.unit_class?.name"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Base Unit</label>
          <input
            type="text"
            disabled
            class="form-control"
            [value]="baseUnit?.name"
          />
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Conversion Unit</label>
          <ng-select
            formControlName="convertedUnitOfMeasureId"
            [items]="unitOfMeasures"
            bindValue="id"
            bindLabel="name"
          >
          </ng-select>
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.convertedUnitOfMeasureId"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Conversion Factor</label>
          <input
            type="number"
            class="form-control"
            formControlName="conversionFactor"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.conversionFactor"
          >
          </control-messages>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-12">
        <label for="">Alternate Skus</label>
        <div class="input-group">
          <ng-select
            class="form-control"
            [items]="alternateSKUs"
            formControlName="alternateSkus"
            bindValue="id"
            bindLabel="alternate_sku"
            multiple="true"
          >
          </ng-select>
          <div class="input-group-append">
            <button
              (click)="updateAlternateSkus()"
              class="btn btn-outline-secondary"
              type="button"
              >Add Alternate SKU</button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-success" [disabled]="loading">
      <i class="fa fa-save"></i> Submit
    </button>
    <button
      type="button"
      class="btn btn-danger"
      (click)="cancel()"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
  </div>
</form>
